<template>
  <div class="oai-GradientProgressBar">
    <div class="oai-GradientProgressBar_Track">
      <div
        :class="{
          'oai-GradientProgressBar_Fill-loading': indeterminate
        }"
        :style="fillStyle"
        class="oai-GradientProgressBar_Fill"
      >
        <div class="oai-GradientProgressBar_Gradient" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { clamp, isNull } from 'lodash'
import { computed } from 'vue'

defineOptions({
  name: 'OnboardingAiGradientProgressBar'
})

const props = defineProps({
  value: {
    type: Number,
    default: null,
    validator: v => isNull(v) || (v >= 0 && v <= 100)
  }
})

const indeterminate = computed(() => isNull(props.value))

const clampedValue = computed(() => {
  if (isNull(props.value)) {
    return null
  }

  return clamp(props.value, 0, 100)
})

const fillStyle = computed(() => {
  if (indeterminate.value) {
    return undefined
  }

  return { width: `${clampedValue.value}%` }
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/gradient-border';

.oai-GradientProgressBar {
  width: 100%;
}

.oai-GradientProgressBar_Track {
  width: 100%;
  height: 8px;
  border-radius: 8px;
  background: $grey-2-next;
  overflow: hidden;
}

.oai-GradientProgressBar_Fill {
  height: 100%;
  overflow: hidden;
  border-radius: inherit;
  transition: width 0.35s ease;

  &-loading {
    width: 100%;
  }
}

.oai-GradientProgressBar_Gradient {
  @extend %oai-gradient-animated-fill;

  height: 100%;
  border-radius: inherit;
  width: 100%;
}
</style>
